import styled from 'styled-components';

interface MultilineTextProps extends React.ComponentPropsWithoutRef<'div'> {
    text?: string;
}

export const MultilineText = ({ text, ...other }: MultilineTextProps) =>
    text ? <MultilineTextElement {...other}>{text}</MultilineTextElement> : null;

const MultilineTextElement = styled.div`
    white-space: pre-wrap;
`;
